import { Component, Input } from '@angular/core';


import { LanguageSwitchComponent } from '../language-switch/language-switch.component';
import { HelpContentComponent } from '../help-content/help-content.component';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styles: [],
  standalone: true,
  imports: [LanguageSwitchComponent, HelpContentComponent]
})
export class PageHeaderComponent {

  @Input() key!: string;
}
